

import { coreXProducts } from './coreProducts';
import { intelligenceProducts } from './intelligenceProducts';
import { financialProducts } from './financialProducts';
import { productivityProducts } from './productivityProducts';
import { legalProducts } from './legalProducts';
import { educationProducts } from './educationProducts';
import { marketingProducts } from './marketingProducts';
import { customProducts } from './customProducts';
import { hrProducts } from './hrProducts';
import { operationsProducts } from './operationsProducts';
import { communicationProducts } from './communicationProducts';
import { industryProducts } from './industryProducts';
import { manufacturingProducts } from './manufacturingProducts';
// serviceHospitalityProducts consolidated into hospitalityProducts
import { consultingProducts } from './consultingProducts';
import { facilitiesProducts } from './facilitiesProducts';
import { healthcareProducts } from './healthcareProducts';
import { mentalHealthProducts } from './mentalHealthProducts';
import { creativeProducts } from './creativeProducts';
import { recruitmentProducts } from './recruitmentProducts';
import { languageTestingProducts } from './languageTestingProducts';
import { oilGasProducts } from './oilGasProducts';
import { technologyProducts } from './technologyProducts';
import { beautyFashionProducts } from './beautyFashionProducts';
import { healthBeautyProducts } from './healthBeautyProducts';
import { hospitalityProducts } from './hospitalityProducts';
import { retailProducts } from './retailProducts';
import { realEstateProducts } from './realEstateProducts';
import { agricultureProducts } from './agricultureProducts';
import { entertainmentProducts } from './entertainmentProducts';
import { comingSoonProducts } from './newComingSoonProducts';
import { productCategories } from './categories';
// Import the missing suite products
import { marketingSalesSuite } from './marketingSalesSuite';
import { facilitiesManagementSuite } from './facilitiesManagementSuite';
import { digitalNewsroomPlatform } from './digitalNewsroomPlatform';
import { qualityAssuranceSystem } from './bpoQualityAssuranceSystem';
import { callRecordingSystem } from './callRecordingSystem';
import { workforceManagementSystem } from './workforceManagementSystem';
import { itServiceDeskPlatform } from './itServiceDeskPlatform';
import { iosAppSuite } from './iosAppSuite';
import { androidAppSuite } from './androidAppSuite';
import { coworkingManagementSuite } from './coworkingManagementSuite';
import { completePayrollSystem } from './completePayrollSystem';
import { globalEmployerOfRecord } from './eorPlatform';
import { completeHrManagementPlatform } from './completeHrManagementPlatform';
import { passengerTransportationManagement } from './passengerTransportationManagement';
import { timeAttendanceSystem } from './timeAttendanceSystem';
// Import new product categories
import { aiMachineLearningProducts } from './aiMachineLearningProducts';
import { developerToolsProducts } from './developerToolsProducts';
import { dataAnalyticsBIProducts } from './dataAnalyticsBIProducts';
import { customerSuccessCRMProducts } from './customerSuccessCRMProducts';
import { industryVerticalProducts } from './industryVerticalProducts';
import { emergingNicheProducts } from './emergingNicheProducts';
import { bpoContactCentreProducts } from './bpoContactCentreProducts';
import { normalizeProductCatalog } from './pricingNormalization';

// Export all products as a flat array - prioritization is handled by utils/productPrioritization.ts
const allProductsRaw = [
  // Live Products First (for homepage priority)
  marketingSalesSuite,
  facilitiesManagementSuite,
  digitalNewsroomPlatform,
  qualityAssuranceSystem,
  callRecordingSystem,
  workforceManagementSystem,
  itServiceDeskPlatform,
  coworkingManagementSuite,
  completePayrollSystem,
  globalEmployerOfRecord,
  completeHrManagementPlatform,
  passengerTransportationManagement,
  timeAttendanceSystem,
  // Extract the Live product from coreXProducts
  ...coreXProducts.filter(p => p.id === 'website-webapp-suite'),
  // Available Products
  iosAppSuite,
  androidAppSuite,
  // Remaining Core Products (excluding the Live one we already added)
  ...coreXProducts.filter(p => p.id !== 'website-webapp-suite'),
  ...intelligenceProducts,
  ...financialProducts,
  ...productivityProducts,
  ...legalProducts,
  ...educationProducts,
  ...marketingProducts,
  ...customProducts,
  ...hrProducts.filter(p => p.id !== 'time-attendance-system'),
  ...operationsProducts,
  ...communicationProducts,
  ...industryProducts,
  ...manufacturingProducts,
  // serviceHospitalityProducts consolidated into hospitalityProducts
  ...consultingProducts,
  ...facilitiesProducts,
  ...healthcareProducts,
  ...mentalHealthProducts,
  ...creativeProducts.filter(p => p.id !== 'digital-asset-management'),
  ...recruitmentProducts,
  ...languageTestingProducts,
  ...oilGasProducts,
  ...technologyProducts,
  ...healthBeautyProducts,
  ...beautyFashionProducts,
  ...hospitalityProducts,
  ...retailProducts,
  ...realEstateProducts,
  ...agricultureProducts,
  ...entertainmentProducts,
  // New product categories (Phase 1 implementation)
  ...aiMachineLearningProducts,
  ...developerToolsProducts,
  ...dataAnalyticsBIProducts,
  ...customerSuccessCRMProducts.filter(p => p.id !== 'contract-lifecycle-management'),
  ...industryVerticalProducts,
  ...emergingNicheProducts,
  // BPO & Contact Centre Products
  ...bpoContactCentreProducts,
];

export const allProducts = normalizeProductCatalog(allProductsRaw);

console.log('📊 Product counts per category:', {
  coreX: coreXProducts.length,
  intelligence: intelligenceProducts.length,
  financial: financialProducts.length,
  productivity: productivityProducts.length,
  legal: legalProducts.length,
  education: educationProducts.length,
  marketing: marketingProducts.length,
  custom: customProducts.length,
  hr: hrProducts.length,
  operations: operationsProducts.length,
  communication: communicationProducts.length,
  industry: industryProducts.length,
  manufacturing: manufacturingProducts.length,
  consulting: consultingProducts.length,
  facilities: facilitiesProducts.length,
  healthcare: healthcareProducts.length,
  mentalHealth: mentalHealthProducts.length,
  creative: creativeProducts.length,
  recruitment: recruitmentProducts.length,
  languageTesting: languageTestingProducts.length,
  oilGas: oilGasProducts.length,
  technology: technologyProducts.length,
  beautyFashion: beautyFashionProducts.length,
  healthBeauty: healthBeautyProducts.length,
  hospitality: hospitalityProducts.length,
  retail: retailProducts.length,
  realEstate: realEstateProducts.length,
  agriculture: agricultureProducts.length,
  entertainment: entertainmentProducts.length,
  aiML: aiMachineLearningProducts.length,
  devTools: developerToolsProducts.length,
  dataAnalytics: dataAnalyticsBIProducts.length,
  customerSuccess: customerSuccessCRMProducts.length,
  industryVertical: industryVerticalProducts.length,
  emergingNiche: emergingNicheProducts.length,
  bpoContactCentre: bpoContactCentreProducts.length,
  total: allProducts.length,
});

// Export additional items that components need
export { comingSoonProducts, productCategories };
